/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  PersonalInfoErrorResponse,
  PersonalInfoRequest,
  PersonalInfoResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updatePatientInfo = (patientId: string, personalInfoRequest: PersonalInfoRequest) => {
  return api<PersonalInfoResponse>({
    url: `/api/patient/${patientId}/info`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: personalInfoRequest,
  });
};

export const getUpdatePatientInfoMutationOptions = <
  TError = PersonalInfoErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePatientInfo>>,
    TError,
    { patientId: string; data: PersonalInfoRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePatientInfo>>,
  TError,
  { patientId: string; data: PersonalInfoRequest },
  TContext
> => {
  const mutationKey = ['updatePatientInfo'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientInfo>>,
    { patientId: string; data: PersonalInfoRequest }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return updatePatientInfo(patientId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePatientInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatientInfo>>
>;
export type UpdatePatientInfoMutationBody = PersonalInfoRequest;
export type UpdatePatientInfoMutationError = PersonalInfoErrorResponse;

export const useUpdatePatientInfo = <TError = PersonalInfoErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePatientInfo>>,
      TError,
      { patientId: string; data: PersonalInfoRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePatientInfo>>,
  TError,
  { patientId: string; data: PersonalInfoRequest },
  TContext
> => {
  const mutationOptions = getUpdatePatientInfoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
